import React from "react";
import i18n from "../../../i18n"

interface Props {
  error?: string;
  isUploading?: boolean;
  success?: string;
}

const LoadingMessages = ({ error, isUploading, success }: Props) => (
  <>
    {error && (
      <p className="text-center text-danger font-weight-bold">{i18n.t(error)}</p>
    )}
    {success && (
      <p className="text-center text-success font-weight-bold">{i18n.t(success)}</p>
    )}
    {isUploading && (
      <p className="text-center text-muted">
        {i18n.t("msg.fileLoading")}
      </p>
    )}
  </>
);

export default LoadingMessages;
